(function() {
  'use strict';

  const RWRSizeGuideSighthound = {
    init: function() {
      this.section = document.querySelector('.rwr-size-guide-sighthound');
      if (!this.section) return;
      
      this.bindEvents();
      this.initAccessibility();
    },

    bindEvents: function() {
      const tableRows = this.section.querySelectorAll('.rwr-size-guide__table tbody tr');
      
      tableRows.forEach(row => {
        row.setAttribute('tabindex', '0');
        
        row.addEventListener('focus', function() {
          this.classList.add('is-focused');
        });
        
        row.addEventListener('blur', function() {
          this.classList.remove('is-focused');
        });
      });
    },

    initAccessibility: function() {
      const table = this.section.querySelector('.rwr-size-guide__table');
      if (table) {
        table.setAttribute('role', 'table');
        table.setAttribute('aria-label', 'Sighthound dog collar size chart');
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => RWRSizeGuideSighthound.init());
  } else {
    RWRSizeGuideSighthound.init();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.rwr-size-guide-sighthound')) {
      RWRSizeGuideSighthound.init();
    }
  });
})();